// Procore push: plain words for each state. Nothing here talks to the network.

export const PROCORE_RETURN = {
  connected: 'Procore is connected.',
  failed: 'Procore didn’t finish connecting. Nothing was saved. Try again.',
  cancelled: 'Procore connection cancelled. Nothing was saved.',
  off: 'Procore isn’t switched on for this account yet.',
};

export function visible(st) {
  return !!st && st.status !== 'off';
}

export function statusLine(st) {
  if (!st) return '';
  const where = st.sandbox ? ' (sandbox)' : '';
  switch (st.status) {
    case 'not_switched_on':
      return 'Coming soon. Send reports straight into your Procore project’s documents.';
    case 'disconnected':
      return `Send site reports into a Procore project’s documents${where}.`;
    case 'needs_reconnect':
      return 'Procore signed this account out. Reconnect to keep sending reports.';
    case 'connected':
      return [st.company && st.company.name, st.account].filter(Boolean).join(' · ') || `Connected${where}`;
    default:
      return '';
  }
}

export function linkLine(link) {
  if (!link) return 'Pick the Procore project these reports go to.';
  return `${link.procore_project_name} · ${link.folder_path || 'Bricks site reports'}`;
}

export function whenLabel(iso) {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function lastPushFor(pushes, reportId) {
  return (pushes || []).filter((p) => String(p.report_id) === String(reportId))
    .sort((a, b) => String(b.pushed_at).localeCompare(String(a.pushed_at)))[0] || null;
}

export function sentLine(push, projectName) {
  if (!push) return '';
  const when = whenLabel(push.pushed_at);
  return `Sent to ${projectName || 'Procore'}${when ? ` ${when}` : ''}`;
}

// What the report sheet shows, or null to show nothing.
export function sheetState(st, reportId) {
  if (!st || st.status === 'off' || st.status === 'not_switched_on' || st.status === 'disconnected') return null;
  if (st.status === 'needs_reconnect') return { canSend: false, line: 'Reconnect Procore on the project page to send this.' };
  if (!st.link) return { canSend: false, line: 'Pick a Procore project on the project page to send this.' };
  const last = lastPushFor(st.pushes, reportId);
  return { canSend: true, line: last ? sentLine(last, st.link.procore_project_name) : `Goes to ${linkLine(st.link)}`, sent: !!last };
}
